const i = {
    CustomEvent: "ce",
    Pr: "p",
    Ku: "pc",
    vc: "ca",
    Ua: "i",
    Ls: "ie",
    M: "cci",
    R: "ccic",
    k: "ccc",
    F: "ccd",
    ql: "ss",
    xl: "se",
    Xi: "si",
    $i: "sc",
    Oi: "sbc",
    Cc: "sfe",
    mo: "iec",
    Ju: "lr",
    Eu: "uae",
    O: "ci",
    D: "cc",
    Xu: "lcaa",
    Gu: "lcar",
    On: "inc",
    Ln: "add",
    Rn: "rem",
    $n: "set",
    Bn: "ncam",
    Hu: "sgu",
    Fr: "ffi",
  },
  or = { Ar: "feed_displayed", Ec: "content_cards_displayed" };
export { i as EventTypes, or as InternalEventTypes };
